import React from 'react';
import { observer } from 'mobx-react';

import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { routeNaming, AppLink } from '../../../routes';
import { SEO } from '../../../common/seo';

import styles from './JoinOurTeam.css';

const JoinOurTeam = observer(() => {
  const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  return (
    <div className={styles.container}>
      <SEO
        title="Unirse a nuestro equipo"
        description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainWrapper}>
        <div className={styles.mainContent}>
          {showMobileVersion ?
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.INFORMATION_MENU_MOBILE}
              >
                Información
              </AppLink>
              <span> &gt; Unirse a nuestro equipo</span>
            </p>
            : <InformationMenu indexSelectedItem={9} className={styles.menu} />}
          <div className={styles.bodyContainer}>
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Unirse a nuestro equipo</h1>
            </div>
            <div className={styles.content}>
              <p className={styles.subtitle}>
                Si querés trabajar con nosotros y sos mayor de 18 años,
                envíanos tu curriculum vitae a:
              </p>
              <ul>
                <li>
                  <span>
                    Atención en mostrador, telefonista, vendedor o entrega de mercadería
                    y otros: <br />
                  </span>
                  <a href="mailto://oportunidadlaboral@carlosgutierrez.com.uy" className={styles.mailLink}>
                    oportunidadlaboral@carlosgutierrez.com.uy
                  </a>
                </li>
                <li>
                  <span>Programadores Full-Stack : </span>
                  <ul>
                    <li>
                      Programación .Net, MVC, WCF, y Entity Framework
                    </li>
                    <li>
                      React JS
                    </li>
                  </ul>
                  a&nbsp;
                  <a href="mailto://informatica@carlosgutierrez.com.uy" className={styles.mailLink}>
                    informatica@carlosgutierrez.com.uy
                  </a>
                </li>
              </ul>
              <br />
              <p>Tus datos serán estudiados confidencialmente.</p>
              <p>Muchas gracias por tu interés en Carlos Gutiérrez S.A.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { JoinOurTeam };



// WEBPACK FOOTER //
// ./src/pages/information/join-our-team/JoinOurTeam.jsx